import React, { Component } from 'react';
import { Pagination, Input, message, Modal, Empty, Select, Button } from 'antd';
import { Redirect } from 'react-router';
import './deviceManagement.less';
import utils from '../../../utils/common';
import Detail from '../../backEnd/facilityMangement/facilitydetail';
import api2 from '../../../api/api2';
import aes from '../../../api/aes/public';

const Option = Select.Option;
const Search = Input.Search;

class DeviceManagement extends Component {
  state = {
    visible: false, // 是否显示modal
    tab: 1, // 0 硬件 1 软件
    confirmLoading: false, // 确认loading
    modalText: '确认解除绑定当前设备？', // 弹窗内容
    isvisible: false, // 显示详情弹窗
    list: [], // 设备列表
    total: 0, // 总条目数
    currentPage: 1, // 当前页数
    searchType: undefined, // 搜索类型
    searchContent: '', // 搜索内容
    bindStatus: undefined, // 绑定状态
    activateStatus: undefined, // 激活状态
    unbindDevice: null, // 解绑的设备详情
    deviceInfo: null, // 设备详情
    activationCodeType: undefined, // 激活码类型
  }

  componentWillMount() {
    if (window.common.loginOut(this)) {
      this.getDeviceList(1);
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  // 获取设备列表
  getDeviceList = (page) => {
    const {
      searchContent, searchType, bindStatus, activateStatus, tab, activationCodeType
    } = this.state;
    let params = {
      page_size: 10,
      current_page: page,
      [searchType]: searchContent,
      bind_status: bindStatus,
      activate_status: activateStatus
    };
    // 仅软、硬件有激活码类型，流量产品无激活码类型
    if (tab !== 2) {
      params.activation_code_type = activationCodeType;
    }
    switch (tab) {
      case 0:
        params.goods_property = 2;
        break;
      case 1:
        params.goods_property = 1;
        break;
      case 2:
        params.goods_property = 3;
        break;
      default:
        null;
        break;
    }
    params = utils.dealElement(params);
    window.api('eps.getordergoodsmanager', params).then(res => {
      this.setState({ list: res.order_goods_manager_list, total: res.total_result, currentPage: page });
    }).catch(error => {
      error.service_error_code === 'EPS000000801' ? this.setState({ redirect: true }) : null;
      message.error(error.service_error_message);
    });
  }

  // 翻页
  changePage = (page) => {
    this.getDeviceList(page);
  }

  // 搜索订单
  searchDevice = async (value) => {
    const { searchType } = this.state;
    if (!searchType && value !== '') {
      message.warn('请选择搜索类型');
      return;
    }
    await this.setState({ searchContent: value });
    this.getDeviceList(1);
  }

  // 改变tab
  changeTabs = async (index) => {
    await this.setState({ tab: index, list: [], total: 0, activationCodeType: undefined });
    this.getDeviceList(1);
  }

  // 改变下拉框
  changeSelect = async (type, value) => {
    await this.setState({ [type]: value });
    type !== 'searchType' ? this.getDeviceList(1) : null;
  }

  // 打开详情
  openDetail = (info) => {
    this.setState({ deviceInfo: info, isvisible: true });
  }

  // 控制弹窗
  changeModal = async (type, value) => {
    let info = {};
    if (type === 'cancel') {
      info = value === 'detail' ? { isvisible: false } : { visible: false };
    } else {
      info = value === 'detail' ? { isvisible: true } : { visible: true, unbindDevice: value };
    }
    await this.setState(info);
  }

  // 获取和新商户key
  getPartnerIdKey = () => {
    const item = this.state.unbindDevice;
    const requestNo = window.common.getRequestNo(16);
    window.localStorage.setItem('platform_no', item.platform_no);
    window.localStorage.setItem('merchant_code', item.bind_core_merchant_code);
    window.localStorage.setItem('request_no', requestNo);
    const params = {
      out_request_no: requestNo, //随机生成
      core_merchant_no: item.bind_core_merchant_code //核心商户编号
    };
    api2.baseInstance('merchant.pidkeyquery', params).then(async (res) => {
      const key = aes.Decrypt(window.localStorage.getItem('PKEY'));
      await window.localStorage.setItem('partnerID', aes.Decrypt(res.partner_id_key, key));
      await this.unbind(item);
    }).catch(error => {
      message.error(error.message);
    });
  }

  // 解绑
  unbind = (item) => {
    const params = {
      out_trade_no: `EPSUNBIND${window.common.getRequestNo(10)}`, //商户请求单号(自动生成)
      merchant_no: item.bind_merchant_code, //门店编号
      identify_type: 'SN', //device_sn
      goods_id: item.goods_id, //商品goods_id
      device_sn: item.device_sn, //sn码
      operator_id: JSON.parse(window.localStorage.getItem('headParams')).login_name, //操作员登录人userName
      notify_url: (window.common.getUrl())[0] //
    };
    window.api('device.unbind', params).then(res => {
      message.success('解绑成功');
      this.getDeviceList(this.state.currentPage);
    }).catch(error => {
      message.error(error.message);
    });
    this.setState({ visible: false });
  }
  getState(status) {
    switch (status) {
      case '1':
        return '已绑定';
      case '2':
        return '未绑定';
      case '3':
        return '锁定中';
      default:
        return '未绑定';
    }
  }
  render() {
    const {
      redirect, list, currentPage, visible, modalText, confirmLoading, total, isvisible, tab, deviceInfo, activationCodeType
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);
    return (
      <div id="deviceManagement">
        <section className="bar" />
        <section className="top">
          <div className="tab">
            <ul>
              <li className={tab === 1 ? 'isChecked' : null} onClick={this.changeTabs.bind(this, 1)}>软件</li>
              <li className={tab === 0 ? 'isChecked' : null} onClick={this.changeTabs.bind(this, 0)}>硬件</li>
              <li className={tab === 2 ? 'isChecked' : null} onClick={this.changeTabs.bind(this, 2)}>流量产品</li>
            </ul>
          </div>
          <div>
            <Select
              style={{ marginRight: '10px' }}
              placeholder="选择搜索类型"
              onChange={this.changeSelect.bind(this, 'searchType')}
            >
              <Option value="goods_name">商品名称</Option>
              <Option value="device_sn">sn码</Option>
            </Select>
            <Search
              className="searchInput"
              placeholder="请输入"
              enterButton="搜索"
              size="default"
              onSearch={this.searchDevice}
            />
          </div>
        </section>
        <section className="bar bar2" />
        <section className="content">
          <ul className="status">
            <li style={{ width: '200px' }}>商品名称</li>
            <li style={{ width: '150px' }}>{tab === 0 ? 'SN码' : '激活码'}</li>
            {tab !== 2 ? (
              <li>
                <Select
                  style={{ width: '120px' }}
                  placeholder="激活码类型"
                  allowClear
                  value={activationCodeType}
                  onChange={this.changeSelect.bind(this, 'activationCodeType')}
                >
                  <Option className="statusOption" value="0">通用型</Option>
                  {tab === 1 ? <Option className="statusOption" value="1">联拓通道专属</Option> : null}
                </Select>
              </li>
            ) : null}
            {tab === 1 ?
              <li style={{ width: '120px' }} className="coreCode">
                <p>有效期</p>
                <p>(天)</p>
              </li> : null}
            <li>
              <Select
                style={{ width: '100px' }}
                placeholder="绑定状态"
                allowClear
                onChange={this.changeSelect.bind(this, 'bindStatus')}
              >
                <Option className="statusOption" value="1">已绑定</Option>
                <Option className="statusOption" value="2">未绑定</Option>
                <Option className="statusOption" value="3">锁定中</Option>
              </Select>
            </li>
            <li style={{ width: '200px' }} className="coreCode">
              <p>商户信息</p>
              <p>门店信息</p>
            </li>
            <li>
              <Select
                style={{ width: '100px' }}
                placeholder="激活状态"
                allowClear
                onChange={this.changeSelect.bind(this, 'activateStatus')}
              >
                <Option className="statusOption" value="1">未激活</Option>
                <Option className="statusOption" value="2">激活中</Option>
                <Option className="statusOption" value="3">已激活</Option>
              </Select>
            </li>
            <li style={{ width: '60px' }}>操作</li>
          </ul>
          <ul className="deviceList">
            {
              list.map((item, index) => (
                <li key={index}>
                  <p style={{ width: '200px', fontSize: '15px', fontWeight: '600', color: '#2c3e50' }}>{item.goods_name}</p>
                  <p style={{ width: '150px', fontFamily: 'monospace', color: '#555' }}>{item.device_sn}</p>
                  {tab !== 2 ? (
                    <p style={{ width: '120px' }}>
                      <span style={{
                        padding: '4px 12px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        background: item.activation_code_type === '0' ? '#e8f5e9' : '#fff3e0',
                        color: item.activation_code_type === '0' ? '#2e7d32' : '#e65100',
                        fontWeight: '500'
                      }}>
                        {item.activation_code_type === 0 ? '通用型' : item.activation_code_type === 1 ? '联拓通道专属' : ''}
                      </span>
                    </p>
                  ) : null}
                  {tab === 1 ? <p style={{ width: '120px', fontWeight: '500', color: '#666' }}>{item.valid_date}</p> : null}
                  <p style={{ width: '100px' }}>
                    <span style={{
                      padding: '4px 12px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: '500',
                      background: item.bind_status === '1' ? '#e3f2fd' : item.bind_status === '3' ? '#ffebee' : '#f5f5f5',
                      color: item.bind_status === '1' ? '#1976d2' : item.bind_status === '3' ? '#c62828' : '#757575'
                    }}>
                      {this.getState(item.bind_status)}
                    </span>
                  </p>
                  <div style={{ width: '200px' }} className="coreCode">
                    <p hidden={!item.bind_core_merchant_code}>
                      <span style={{ fontWeight: '500' }}>{item.bind_core_merchant_code}</span>
                      <span style={{ color: '#999', marginLeft: '4px' }}>/ {item.bind_core_merchant_name}</span>
                    </p>
                    <p hidden={!item.bind_merchant_code}>
                      <span style={{ fontWeight: '500' }}>{item.bind_merchant_code}</span>
                      <span style={{ color: '#999', marginLeft: '4px' }}>/ {item.bind_merchant_name}</span>
                    </p>
                  </div>
                  <p style={{ width: '100px' }}>
                    <span style={{
                      padding: '4px 12px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: '500',
                      background: item.activate_status === '3' ? '#e8f5e9' : item.activate_status === '2' ? '#fff3e0' : '#f5f5f5',
                      color: item.activate_status === '3' ? '#2e7d32' : item.activate_status === '2' ? '#f57c00' : '#757575'
                    }}>
                      {item.activate_status === '1' ? '未激活' : item.activate_status === '2' ? '激活中' : '已激活'}
                    </span>
                  </p>
                  <div className="operation" style={{ width: '60px' }}>
                    <p onClick={this.openDetail.bind(this, item)}>详情</p>
                    <p onClick={this.changeModal.bind(this, 'open', item)} hidden={item.bind_status !== '1' || item.goods_property === '1'}>解绑</p>
                  </div>
                </li>
              ))
            }
          </ul>
        </section>
        <section className="pagination" hidden={Number(total) === 0}>
          <Pagination
            showQuickJumper
            showSizeChange
            current={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            total={total}
            onChange={this.changePage}
          />
        </section>
        <section className="default" hidden={list.length > 0}>
          <Empty />
        </section>
        <div>
          <Modal
            visible={visible}
            onOk={this.getPartnerIdKey}
            confirmLoading={confirmLoading}
            onCancel={this.changeModal.bind(this, 'cancel')}
          >
            <p>{modalText}</p>
          </Modal>
          <Modal
            title="详情"
            visible={isvisible}
            onCancel={this.changeModal.bind(this, 'cancel', 'detail')}
            width="700px"
            footer={
              <Button onClick={this.changeModal.bind(this, 'cancel', 'detail')}>关闭</Button>
            }
          >
            <Detail form={deviceInfo} />
          </Modal>
        </div>
      </div>
    );
  }
}

export default DeviceManagement;



// WEBPACK FOOTER //
// ./src/containers/frontEnd/deviceManagement/deviceManagement.jsx